/**
 * Classification des payloads scanner caisse (douchette clavier).
 * QR Clickorico client / retrait : réservés — ne pas confondre avec GTIN retail.
 */

const CLICKORICO_CLIENT_PREFIXES = ['CLKC:CLIENT:', 'CLKC:FID:'];
const CLICKORICO_PICKUP_PREFIXES = ['CLKC:PICKUP:', 'CLKC:CC:'];

export const POS_SCAN_KIND = {
  RETAIL_GTIN: 'RETAIL_GTIN',
  CLICKORICO_INTERNAL: 'CLICKORICO_INTERNAL',
  CLICKORICO_CLIENT: 'CLICKORICO_CLIENT',
  CLICKORICO_PICKUP: 'CLICKORICO_PICKUP',
  UNKNOWN: 'UNKNOWN',
};

const CLKI_PREFIX = 'CLKI';
const CLKI_CODE_REGEX = /^CLKI[0-9A-HJKMNP-Z]{8}$/;

function normalizeInternalCode(raw) {
  const upper = String(raw || '').trim().toUpperCase();
  if (!CLKI_CODE_REGEX.test(upper)) return null;
  return upper;
}

export function digitsOnly(raw) {
  return String(raw || '').replace(/\D/g, '');
}

export function isLikelyRetailGtin(raw) {
  const d = digitsOnly(raw);
  return [8, 12, 13, 14].includes(d.length);
}

/** Code scannable complet (CLKI 12 car. ou GTIN retail valide en longueur). */
export function isCompleteRetailScanCode(raw) {
  const classified = classifyPosScanPayload(raw);
  return (
    classified.kind === POS_SCAN_KIND.CLICKORICO_INTERNAL ||
    classified.kind === POS_SCAN_KIND.RETAIL_GTIN
  );
}

/** CLKI commencé mais pas encore complet — ne pas appeler l’API caisse. */
export function isPartialInternalScanCode(raw) {
  const upper = String(raw || '').trim().toUpperCase();
  if (!upper.startsWith(CLKI_PREFIX)) return false;
  return !CLKI_CODE_REGEX.test(upper);
}

export function classifyPosScanPayload(raw) {
  const trimmed = String(raw || '').trim();
  if (!trimmed) return { kind: POS_SCAN_KIND.UNKNOWN, raw: trimmed };
  const upper = trimmed.toUpperCase();
  if (CLICKORICO_CLIENT_PREFIXES.some((p) => upper.startsWith(p))) {
    return { kind: POS_SCAN_KIND.CLICKORICO_CLIENT, raw: trimmed };
  }
  if (CLICKORICO_PICKUP_PREFIXES.some((p) => upper.startsWith(p))) {
    return { kind: POS_SCAN_KIND.CLICKORICO_PICKUP, raw: trimmed };
  }
  if (upper.startsWith(CLKI_PREFIX)) {
    const internalCode = normalizeInternalCode(trimmed);
    if (internalCode) {
      return { kind: POS_SCAN_KIND.CLICKORICO_INTERNAL, raw: trimmed, internalCode };
    }
    return { kind: POS_SCAN_KIND.UNKNOWN, raw: trimmed };
  }
  if (/^https?:\/\//i.test(trimmed) && /clickorico/i.test(trimmed)) {
    return { kind: POS_SCAN_KIND.UNKNOWN, raw: trimmed };
  }
  if (isLikelyRetailGtin(trimmed)) {
    return { kind: POS_SCAN_KIND.RETAIL_GTIN, raw: trimmed, gtin: digitsOnly(trimmed) };
  }
  return { kind: POS_SCAN_KIND.UNKNOWN, raw: trimmed };
}
